module.exports = "/images/estoc4.jpg?4e4d3a195ade4e32e7a62c77fa5c8d86";